import React, { useState } from 'react'
import RichText from 'src/utils/RichText'
import Heading from 'src/utils/Heading'
import Button from 'src/utils/Button'

const OneColumnTextReadMore = ({ blok }) => {
    const [contentVisible, setContentVisible] = useState(false)
    return (
        <div className="overflow-hidden">
            <div className="max-w-7xl mx-auto my-20 px-6 lg:px-12">
                <div className="max-w-[986px] mr-auto">
                    <Heading size="h2" className="lg:text-[44px] md:text-4xl text-2xl !leading-tight mb-7 sm:mb-9">{blok.client_name}</Heading>
                    <Heading size="h2" className="lg:text-6xl md:text-5xl text-4xl !leading-tight">{blok.title}</Heading>
                    <div className="prose md:mt-12 mt-8 max-w-full">
                        <RichText>{blok.content}</RichText>
                    </div>
                    <div class={`${contentVisible ? 'max-h-screen' : 'max-h-0'} duration-1000 overflow-hidden prose max-w-full mt-8`}>
                        <RichText>{blok.read_more_content}</RichText>
                    </div>
                    {!contentVisible &&
                        <Button className="mt-8" onClick={()=> setContentVisible(true)}>
                            Read more
                        </Button>
                    }
                </div>
            </div>
        </div>
    )
}

export default OneColumnTextReadMore
